import { forwardRef } from 'react';
import IconBase from '../IconBase';
import { Icon } from '../types';

const Fuse: Icon = forwardRef((props, ref) => (
  <IconBase viewBoxBase={780} ref={ref} {...props}>
    <path d='m660 660h-540v-540h465c41.36 0 75 33.64 75 75zm-510-30h480v-435c0-24.81-20.19-45-45-45h-435z' />
    <path d='m570 360h-360s0-30 0-30h330c16.57 0 30 13.43 30 30z' />
    <path d='m270 450v-100s30 0 30 0v70c0 16.57-13.43 30-30 30z' />
    <path d='m375 450v-100s30 0 30 0v70c0 16.57-13.43 30-30 30z' />
    <path d='m480 450v-100s30 0 30 0v70c0 16.57-13.43 30-30 30z' />
    <path d='m140 240h500v30h-500z' />
    <path d='m140 510h500v30h-500z' />
  </IconBase>
));

Fuse.displayName = 'Fuse';

export default Fuse;
